import store from "../../../store";
import pwa_action_groups from "../../catalog/actions/groups/pwa_action_groups.vue";
import pwa_action_list from "../../catalog/actions/list/pwa_action_list.vue";

window.pwa_actions =  new Vue({
    store,
    el: 'div#pwa_action',

    name : "pwa_action",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        pwa_action_list,
        pwa_action_groups
    }
});
